"use client"

import { aboutImg, aboutShapeImg } from '@/assets/imgs'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'


type Props = {
  className: string
}

const AboutUs = ({ className }: Props) => {
  const  t  = useTranslations()
  return (
    <div
      className={`${className} flex flex-col items-center justify-between gap-16 bg-cover bg-center bg-no-repeat lg:flex-row lg:items-start lg:bg-aboutBG`}
    >
      <div className='relative order-2 flex w-full items-center justify-center sm:w-3/4 lg:w-2/5'>
        <Image
        alt='about us shape'
          src={aboutShapeImg}
          className='absolute left-1/2 top-1/2  -translate-x-1/2 -translate-y-1/2'
        />
        <Image alt='about image' src={aboutImg} className='aspect-square h-4/5 w-4/5' />
      </div>
      <div className='relative order-1 flex-1'>
        <p className='mb-4 ps-24 text-sm font-light uppercase before:absolute before:top-2 before:h-1 before:w-3 before:bg-orange after:absolute after:top-2 after:h-1 after:w-12 after:bg-orange ltr:before:left-0 ltr:after:left-6 rtl:text-base rtl:font-semibold rtl:before:right-0 rtl:after:right-6'>
          {t('links.aboutUs')}
        </p>
        <div className='flex flex-col gap-10'>
          <h3 className='text-4xl font-bold'>
            {t('homePage.welcomeTo')} Code Horizon
          </h3>
          <p className='text-lg'>{t('homePage.aboutContentOne')}</p>
          <p className='text-lg'>{t('homePage.aboutContentTwo')}</p>
          <Link
            href='/about'
            className='w-fit rounded-lg border border-black bg-white to-100% px-9 py-4 font-semibold text-secondary transition-all duration-500 hover:bg-linear-to-r hover:from-primary hover:from-50% hover:to-secondary hover:text-white'
          >
            {t('homePage.learnMore')}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AboutUs
